import ReadUTMQueryParameters from "../hooks/use-localstorage.hook";

export const generateApplyURL = (brandId: string, courseId: string): string => {
  const baseURL = process.env.NEXT_PUBLIC_INTO_STUDY_APPLY_URL as string;
  let url = `${baseURL}/application/course/${brandId}/${courseId}`;

  const utmParams = ReadUTMQueryParameters();

  if (utmParams) {
    url = `${url}?${utmParams}`;
  }

  return url;
};
